exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rotator-5-wrapper[data-v-3dd16f3e]{width:auto;max-width:410px;padding-bottom:10px}.rg-rotator-5-content[data-v-3dd16f3e]{min-width:350px}@media screen and (max-width:700px){.rg-rotator-5-content[data-v-3dd16f3e]{min-width:auto}}", ""]);

// exports
